var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"ny-carousel",attrs:{"tag":"div","name":"slide"}},[_vm._l((_vm.images),function(img,i){return [_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.active === i),expression:"active === i"}],key:`nyc-${i}`,attrs:{"src":img}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }